import { analyticsSnapshot, delay } from '../data/mock-store';

export interface AnalyticsData {
  users: { total: number; founders: number; mentors: number; admins: number; investors: number; pendingMentors?: number };
  courses: { total: number; published: number; draft: number; archived: number };
  enrollments: { total: number; completed: number };
  sessions: { total: number; completed: number; scheduled: number; cancelled: number };
  pitches: { totalIdeas: number; approvedIdeas: number; totalPitches: number; approvedPitches: number; publishedPitches: number };
  startups: { total: number; byStage: { idea: number; 'pre-seed': number; seed: number; 'series-a': number } };
  submissions: { total: number; reviewed: number };
  phasePipeline: { phaseId: string; title: string; founderCount: number }[];
  charts: { monthlyUsers: number[]; monthlyEnrollments: number[]; monthlySessions: number[] };
  recentUsers: { _id: string; name: string; role: string; createdAt: string }[];
}

export const getAnalytics = async (): Promise<AnalyticsData> => {
  await delay();
  return { ...analyticsSnapshot };
};
